module.exports = __webpack_public_path__ + "static/bedeho-a2447837e8a3edbb93d4ebd7ff7ef004.png";